export const Api = process.env.REACT_APP_DEVELOPMENT_URL;
// export const Api= 'https://rzme37fl8g.execute-api.us-east-1.amazonaws.com/dev/api/v1';